import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { setPreviousUrl } from '~src/bootstrap/redux/actions/SetPreviousUrlReducerAction';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { ConnectedQueryParamUpdateProvider,QueryParamUpdateProviderOwnProps } from '~src/bootstrap/routerHelpers/QueryParamUpdateProvider';
import { RequestAccessAction } from '~src/requestAccess/actions/RequestAccessAction';
import { RequestAccessContent } from '~src/requestAccess/components/RequestAccessDialog';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { Messages } from '../../codegen/Localize';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { ConnectedHome } from './ConnectedHome';
import { HomeOwnProps, HomeProps } from './Home';

export interface HomeSpaceProviderOwnProps {
  readonly routeLocationSearch: string;
  readonly siteName: string;
  readonly requestAccessContent: RequestAccessContent;
  readonly requestAccessDisplay: boolean;
  readonly requestAccessUrl: string;
  readonly renderHomeSpace: (props: HomeOwnProps) => JSX.Element;
}

export interface HomeSpaceProviderDispatchProps {
  readonly setPreviousUrl: (previousUrl: string) => void;
}

export interface HomeSpaceProviderStateProps {
}

export type HomeSpaceNonAngularProps =  HomeSpaceProviderStateProps & HomeSpaceProviderOwnProps & HomeSpaceProviderDispatchProps;

export type HomeSpaceProviderContainerProps =  HomeSpaceProviderStateProps & HomeSpaceProviderOwnProps &  HomeSpaceProviderDispatchProps;

export interface HomeSpaceProviderContainerState {
  readonly initialRender: boolean;
  readonly hasError: boolean;
  readonly errorCode: number;
  readonly location: string;
}

const InitialState: HomeSpaceProviderContainerState = {
  initialRender: true,
  hasError: false,
  errorCode: undefined,
  location: undefined
};

export class HomeSpaceProviderContainer extends React.PureComponent<HomeSpaceProviderContainerProps, HomeSpaceProviderContainerState> {
  private unmounted: boolean = false;

  public constructor(props: HomeSpaceProviderContainerProps){
    super(props);
    this.state = InitialState;
  }

  public render() {
    return this.props.renderHomeSpace({
      siteName: this.props.siteName,
    });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate(prevProps: HomeSpaceProviderContainerProps) {
    if (this.state.initialRender) {

      this.setState({initialRender: false, }, () => {
        if (this.props.requestAccessDisplay) {
          RequestAccessAction.handleRequestAccess(this.props.requestAccessContent, this.props.requestAccessUrl);
          this.removeRequestAccessDialogUrlParams();
        }
      });
    }
  }

  private removeRequestAccessDialogUrlParams = () => {
    const homeUrl = window.location.href;
    this.props.setPreviousUrl(homeUrl);
  };
}

const mapStateToProps: MapStateToProps<HomeSpaceProviderStateProps> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state),
});

const mapDispatchToProps: MapDispatchToProps<HomeSpaceProviderDispatchProps, HomeSpaceProviderOwnProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  enterSpace,
  setPreviousUrl,
}, dispatch);

export const ConnectedHomeSpaceProviderContainer: React.ComponentClass<HomeSpaceProviderOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(HomeSpaceProviderContainer);

const renderHomeSpace = (props: HomeProps): JSX.Element => <ConnectedHome {...props} />;

export interface LocationPathProp {
  readonly routeLocationPath: string;
}
export type HomeSpaceProviderProps = LocationPathProp & Omit<HomeSpaceProviderOwnProps, 'renderHomeSpace' | 'fetchedAllData'>;

export interface HomeSpaceProviderState {
  readonly fetchedAllData: boolean;
}

export class HomeSpaceProvider extends React.PureComponent<HomeSpaceProviderProps, HomeSpaceProviderState> {
  private HomeSpaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'home',
    subspaceName: undefined
  };

  public render() {
    const queryUpdaterProps: QueryParamUpdateProviderOwnProps = {
      routeLocationPath: this.props.routeLocationPath,
      routeLocationSearch: this.props.routeLocationSearch,
      shouldUpdateContentTypes: true,
      shouldUpdateFilters: false,
      shouldUpdateSort: true,
      shouldUpdateBreadcrumbs: false
    };

    return (
      <ConnectedSpaceInfoProvider spaceInfo={this.HomeSpaceInfo}>
        <ConnectedQueryParamUpdateProvider {...queryUpdaterProps}>
          <ConnectedHomeSpaceProviderContainer {...{...this.props, renderHomeSpace}}/>
        </ConnectedQueryParamUpdateProvider>
      </ConnectedSpaceInfoProvider>
    );
  }

  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.home_browserTitle() });
  }
}